module.exports = __webpack_public_path__ + "6b46a59207ad1d21324a6144cd782f73.jpg";